import { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Resource from "./Resource";
import ThriveModal from "../../common/ThriveModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import ThriveTitle from "../../common/ThriveTitle";

import ThriveCaseSelection from "../../common/ThriveCaseSelection";
import ThriveResourceEditor from "../../common/ThriveResourceEditor";
import { StyledButtonMain } from "../../common/Buttons";
import FactSheetsList from "./FactsheetsList";
import ResourceNotes from "./ResourceNotes";
import ResourceHis from "./ResourceHis";
import DirectoryLayout, { touchLinkRow } from "../Directory/DirectoryLayout";
import CaseReferralBanner from "../Directory/CaseReferralBanner";
import { useDirectoryList } from "../Directory/useDirectoryList";
import { axiosInstance } from "../../../utils/networking";
export interface resourceData {
  _id: string;
  id: string;
  title: string;
  description: string;
  url: string;
  tags: string[];
  imagePath: string;
  orgName: string;
  address: string;
  typeOfResource: string;
  poc: string;
  phone: string;
  email: string;
}

export interface tagsData {
  tag: string;
}

export interface categoryWiseTagsData {
  name: string;
  tags: string[];
}

export interface resourceTag {
  name: string;
  category: string;
}

const categoryOf = (resource: resourceData) => resource.typeOfResource;

const matchesSearch = (resource: resourceData, query: string) =>
  typeof resource.orgName === "string" &&
  resource.orgName.toLowerCase().includes(query);

function ResourceList(props: any) {
  // const tags = props.availableTags.filter((tag: any) => {
  //   if (!(tag.value == "HIDDEN" && !props.user)) {
  //     return tag;
  //   }
  // });
  // Edit reousrce states
  const [resourceEditorOpen, setResourceEditorOpen] = useState(false);

  const navigate = useNavigate();
  const [selectedResource, setSelectedResource] = useState<resourceData | null>(
    null,
  );
  const [editingResource, setEditingResource] = useState({});
  const [cardOpen, setCardOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [availableResources, setAvailableResources] = useState<resourceData[]>(
    [],
  );
  const [availableTags, setAvailableTags] = useState<string[]>([]);

  const [checkedCases, setCheckedCases] = useState<string[]>([]);
  const [selectedCase, setSelectedCase] = useState<any>({ firmRecord: {} });
  const [resourceFactsheetOpen, setResourceFactsheetOpen] = useState(false);
  const [resourceNotesOpen, setResourceNotesOpen] = useState(false);
  const [hisOpen, setHisOpen] = useState(false);
  const [hisResource, setHisResource] = useState<resourceData | null>(null);
  const [searchParams] = useSearchParams();
  const [referralNotificationOpen, setReferralNotificationOpen] =
    useState(false);
  const [referralCaseData, setReferralCaseData] = useState<any>(null);
  const [noCaseFoundOpen, setNoCaseFoundOpen] = useState(false);
  //banner-only flag - the modal above is dismissable, the banner is not
  const [caseLookupFailed, setCaseLookupFailed] = useState(false);
  const deepLinkCaseId = searchParams.get("case_id");

  //keyed on the case id alone, so paging (?page=) does not open the notice
  //again
  useEffect(() => {
    if (!deepLinkCaseId) {
      return;
    }
    axiosInstance
      .get(`/cases/caseToFirmMapping?case_ids=${deepLinkCaseId}`)
      .then((res) => {
        if (res.status === 200) {
          setReferralCaseData(res.data);
          if (res.data && res.data[deepLinkCaseId]) {
            setCaseLookupFailed(false);
            setReferralNotificationOpen(true);
          } else {
            setCaseLookupFailed(true);
            setNoCaseFoundOpen(true);
          }
        }
      })
      .catch(() => {
        setCaseLookupFailed(true);
      });
  }, [deepLinkCaseId]);
  useEffect(() => {
    axiosInstance.get(`/resources`).then((res) => {
      setAvailableResources(res.data.resources);
    });
  }, [openEdit]);

  useEffect(() => {
    axiosInstance.get(`/tags`).then((res) => {
      setAvailableTags(res.data.tags);
    });
  }, []);

  const list = useDirectoryList({
    items: availableResources,
    availableTags,
    categoryOf,
    matchesSearch,
  });

  const handleReferral = () => {
    let selectedCaseID: any, resourceID, firmID;
    if (selectedCase !== null) {
      selectedCaseID = selectedCase["_id"];
      firmID = selectedCase["firm"];
    }
    if (selectedResource !== null) {
      resourceID = selectedResource["id"];
    }

    let referral = {
      _id: "",
      case_id: selectedCaseID,
      resource_id: resourceID,
      firm_id: firmID,
      referral_type: "Resource",
      referral_date: new Date(),
    };

    axiosInstance
      .post(`/referral`, {
        activity_type: "Referral",
        referral: referral,
      })
      .then((res) => {
        if (res.status === 200) {
          setCardOpen(false);
          navigate(`/case?id=${selectedCaseID}`);
        } else {
          console.log("API Error");
        }
      });
  };

  const handleAddNewResource = () => {
    setEditingResource({});
    setResourceEditorOpen(true);
  };

  const handleExport = () => {
    //Export to xlsx file
    const XLSX = require("xlsx");
    const wb = XLSX.utils.book_new();
    const exportResources = availableResources.map((resource: resourceData) => {
      return {
        Organization: resource.orgName,
        POC: resource.poc,
        Phone: resource.phone,
        Email: resource.email,
      };
    });
    const ws = XLSX.utils.json_to_sheet(exportResources);
    XLSX.utils.book_append_sheet(wb, ws, "Resources");
    XLSX.writeFile(wb, "Resources.xlsx");

    axiosInstance.post("/export_log", {
      export_type: "resources",
      record_count: availableResources.length,
      filters: {},
    });
  };

  const handleConfirmReferral = () => {
    const caseId = searchParams.get("case_id");
    if (
      caseId &&
      selectedResource &&
      referralCaseData &&
      referralCaseData[caseId]
    ) {
      const referral = {
        _id: "",
        case_id: caseId,
        resource_id: selectedResource.id,
        firm_id: referralCaseData[caseId]._id,
        referral_type: "Resource",
        referral_date: new Date(),
      };

      axiosInstance
        .post(`/referral`, {
          activity_type: "Referral",
          referral: referral,
        })
        .then((res) => {
          if (res.status === 200) {
            setReferralNotificationOpen(false);
            navigate(`/case?id=${caseId}`);
          } else {
            console.log("API Error");
          }
        });
    }
  };

  const handleConnectToCase = (resource: resourceData) => {
    if (referralCaseData && searchParams.get("case_id")) {
      setSelectedResource(resource);
      setReferralNotificationOpen(true);
    } else {
      setSelectedResource(resource);
      setCardOpen(true);
    }
  };

  return (
    <div className="">
      <DirectoryLayout
        list={list}
        itemNoun="resource"
        banner={
          deepLinkCaseId && (
            <CaseReferralBanner
              failed={caseLookupFailed}
              companyName={referralCaseData?.[deepLinkCaseId]?.["Company Name"]}
              hint="Pick a resource below and click Connect to Case to send this client a resource referral."
              onBack={() => navigate(`/case?id=${deepLinkCaseId}`)}
            />
          )
        }
        searchLabel="Search Resources"
        adminActions={
          props.user.role === "admin" && (
            <>
              <StyledButtonMain
                variant="contained"
                onClick={handleAddNewResource}
              >
                Add new Resource
              </StyledButtonMain>
              <Stack
                direction={"row"}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  ...touchLinkRow,
                }}
              >
                <button
                  className="text-magenta underline"
                  onClick={handleExport}
                >
                  Export
                </button>
              </Stack>
            </>
          )
        }
        cardSpacing={1}
        renderItem={(resource) => (
          <Resource
            key={resource._id || resource.id || resource.orgName}
            tagDisplay={true}
            handleTagClick={list.showOnlyTag}
            resourceContent={resource}
            setResourceEditorOpen={setResourceEditorOpen}
            setEditingResource={setEditingResource}
            setSelectedResource={setSelectedResource}
            setResourceFactsheetOpen={setResourceFactsheetOpen}
            setResourceNotesOpen={setResourceNotesOpen}
            setHisOpen={setHisOpen}
            setHisResource={setHisResource}
            handleConnectToCase={handleConnectToCase}
          />
        )}
      />

      {/* Select Case Popup Box*/}
      <ThriveModal
        height={720}
        open={cardOpen}
        setOpen={setCardOpen}
        contentComponent={
          <ThriveCaseSelection
            height={450}
            cases={[]}
            reloadCases={true}
            checkedCases={checkedCases}
            setCheckedCases={setCheckedCases}
            selectedCase={selectedCase}
            setSelectedCase={setSelectedCase}
            enableControl={true}
            enableSelection={true}
            enableMultiSelection={false}
            setOpen={setCardOpen}
            status_default="either"
            sortby_default="recent"
            period_default="all"
            title="Select Connecting Case"
            handleNext={handleReferral}
          ></ThriveCaseSelection>
        }
      ></ThriveModal>
      <ThriveModal
        open={resourceEditorOpen}
        setOpen={setResourceEditorOpen}
        contentComponent={
          <ThriveResourceEditor
            setOpen={setResourceEditorOpen}
            editorType={"Resource"}
            title={"Resource Editor"}
            editingResource={editingResource}
          ></ThriveResourceEditor>
        }
      ></ThriveModal>

      {/* modal for resource factsheets */}
      <ThriveModal
        open={resourceFactsheetOpen}
        setOpen={setResourceFactsheetOpen}
        contentComponent={
          <FactSheetsList
            setOpen={setResourceFactsheetOpen}
            resource={selectedResource}
          ></FactSheetsList>
        }
      ></ThriveModal>

      {/* modal for resource notes */}
      <ThriveModal
        open={resourceNotesOpen}
        setOpen={setResourceNotesOpen}
        contentComponent={
          <ResourceNotes
            setOpen={setResourceNotesOpen}
            resource={selectedResource}
            editorType={"Resource"}
          ></ResourceNotes>
        }
      ></ThriveModal>

      {/* modal for resource his */}
      <ThriveModal
        open={hisOpen}
        setOpen={setHisOpen}
        contentComponent={
          <ResourceHis
            setOpen={setHisOpen}
            hisResource={hisResource}
          ></ResourceHis>
        }
      ></ThriveModal>

      <ThriveModal
        open={referralNotificationOpen}
        setOpen={setReferralNotificationOpen}
        contentComponent={
          selectedResource ? (
            <Box sx={{ textAlign: "center" }}>
              <ThriveTitle
                title="Referral Confirmation"
                setOpen={setReferralNotificationOpen}
              />
              <Typography sx={{ mt: 2 }}>
                Are you sure you want to refer the following resource to the
                case?
              </Typography>
              <Box sx={{ my: 2, textAlign: "left", display: "inline-block" }}>
                <Typography>
                  <strong>Resource:</strong> {selectedResource?.orgName}
                </Typography>
                <Typography>
                  <strong>Case:</strong>{" "}
                  {referralCaseData && searchParams.get("case_id")
                    ? referralCaseData[searchParams.get("case_id")!]
                      ? referralCaseData[searchParams.get("case_id")!][
                          "Company Name"
                        ]
                      : ""
                    : ""}
                </Typography>
              </Box>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "center", mt: 3 }}
              >
                <Button
                  variant="outlined"
                  onClick={() => setReferralNotificationOpen(false)}
                  sx={{
                    color: "#9D2362",
                    borderColor: "#9D2362",
                    "&:hover": {
                      backgroundColor: "rgba(157, 35, 98, 0.04)",
                      borderColor: "#9D2362",
                    },
                  }}
                >
                  Cancel
                </Button>
                <StyledButtonMain
                  variant="contained"
                  onClick={handleConfirmReferral}
                >
                  Confirm
                </StyledButtonMain>
              </Stack>
            </Box>
          ) : (
            <Box sx={{ textAlign: "center" }}>
              <ThriveTitle
                title="Referral Notice"
                setOpen={setReferralNotificationOpen}
              />
              <Typography sx={{ mt: 2 }}>
                You are now referring resource to the following case:
              </Typography>
              <Typography sx={{ mt: 2, mb: 2, fontWeight: "bold" }}>
                {referralCaseData && searchParams.get("case_id")
                  ? referralCaseData[searchParams.get("case_id")!]
                    ? referralCaseData[searchParams.get("case_id")!][
                        "Company Name"
                      ]
                    : ""
                  : ""}
              </Typography>
              <StyledButtonMain
                sx={{ position: "relative", top: "20px" }}
                variant="outlined"
                size="large"
                onClick={() => setReferralNotificationOpen(false)}
              >
                Close
              </StyledButtonMain>
            </Box>
          )
        }
      ></ThriveModal>

      <ThriveModal
        open={noCaseFoundOpen}
        setOpen={setNoCaseFoundOpen}
        contentComponent={
          <Box sx={{ textAlign: "center" }}>
            <ThriveTitle title="Notice" setOpen={setNoCaseFoundOpen} />
            <Typography sx={{ mt: 2 }}>
              No case is found. Please select a case from the dashboard.
            </Typography>
            <StyledButtonMain
              variant="contained"
              sx={{ mt: 3 }}
              onClick={() => {
                setNoCaseFoundOpen(false);
                navigate("/dashboard/resources");
              }}
            >
              Close
            </StyledButtonMain>
          </Box>
        }
      ></ThriveModal>
    </div>
  );
}

export default ResourceList;
